import React, { useState } from "react";

function EntityEmptyState({ icon, entityName, messages, isFiltered, onAdd, addLabel }) {
    const [message] = useState(
        () => messages[Math.floor(Math.random() * messages.length)]
    );

    return (
        <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
            <div
                className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                style={{ width: 80, height: 80, background: "rgba(0,115,183,0.08)" }}
            >
                <i className={`fa ${icon} fa-2x text-primary`} />
            </div>
            <h5 className="text-muted mb-1">
                {isFiltered ? `No ${entityName} Found` : message}
            </h5>
            <p className="text-muted small mb-3" style={{ maxWidth: 320 }}>
                {isFiltered
                    ? `No ${entityName.toLowerCase()} match your search. Try adjusting the filter.`
                    : `No ${entityName.toLowerCase()} have been configured yet.`}
            </p>
            {!isFiltered && onAdd && (
                <button className="btn btn-primary btn-sm" onClick={onAdd}>
                    <i className="fa fa-plus me-1" />
                    {addLabel || `Create ${entityName}`}
                </button>
            )}
        </div>
    );
}

export default EntityEmptyState;
